// @flow
import { type Node } from 'react';

type Props = {
  text: ?string,
}

const CellText = ({ text }: Props): Node => {
  return (text || '—');
};

export default CellText;
